// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__tl7Ld","empty":"ModalGraph_empty__2pHsr"};